import { route } from "../router/route";

export const tabList = [
  { title: "계정 관리", path: route.my_page_setting },
  { title: "내 활동 관리", path: route.my_page_activity },
  { title: "나의 강의실", path: route.my_page_classroom },
  { title: "스크랩", path: route.my_page_scrap },
  { title: "결제 내역", path: route.my_page_payment },
];

export const activitySubTabList = [
  { title: "내가 쓴 글", path: route.my_page_activity },
  { title: "내가 쓴 댓글", path: route.my_page_activity_comment },
  { title: "후기 관리", path: route.my_page_activity_review },
  { title: "쿠폰 관리", path: route.my_page_activity_coupon },
];

export const classroomSubTabList = [
  { title: "수강 중인 강의", path: route.my_page_classroom },
  { title: "수강 완료 강의", path: route.my_page_classroom_complete },
];

export const scrapSubTabList = [
  { title: "강의", path: route.my_page_scrap },
  { title: "칼럼", path: route.my_page_scrap_column },
];

export const paymentSubTabList = [
  { title: "구독 관리", path: route.my_page_payment },
  { title: "결제 내역 조회", path: route.my_page_payment_history },
  { title: "환불 신청 내역", path: route.my_page_payment_refund },
];
